export default "__VITE_ASSET__BQrTpWxu__"